var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.wrapperProfile
  }, [_c('h2', {
    class: _vm.$style.heading
  }, [_vm._v("\n      Пароль успешно "), _c('br'), _vm._v(" изменён!\n    ")])]), _vm._v(" "), _c('div', {
    class: _vm.$style.wrapperBtn
  }, [_c('SButton', {
    class: _vm.$style.closeBtn,
    on: {
      "click": function click($event) {
        return _vm.$emit('exit');
      }
    }
  }, [_vm._v("\n      Закрыть\n    ")])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };